import { RadioPropertiesType } from "@website/ui/radio/radio.types";
import pick from "lodash-es/pick";

export const useRadio = (properties: RadioPropertiesType) => ({
  inputProps: {
    ...pick(
      properties,
      "autoFocus",
      "disabled",
      "checked",
      "name",
      "onChange",
      "readOnly",
      "value"
    ),
    type: "radio"
  }
});
